export default "__VITE_ASSET__iJhcA9B6__"